var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41068 13.9222C4.25889 13.765 4.17489 13.5545 4.17679 13.336C4.17869 13.1175 4.26633 12.9085 4.42084 12.754C4.57534 12.5995 4.78435 12.5118 5.00285 12.5099C5.22135 12.508 5.43185 12.592 5.58902 12.7438L9.16652 16.3213L9.16652 1.66634C9.16652 1.44533 9.25432 1.23337 9.4106 1.07709C9.56688 0.920805 9.77884 0.833008 9.99985 0.833008C10.2209 0.833008 10.4328 0.920805 10.5891 1.07709C10.7454 1.23337 10.8332 1.44533 10.8332 1.66634L10.8332 16.3213L14.4107 12.7438C14.5679 12.592 14.7784 12.508 14.9969 12.5099C15.2153 12.5118 15.4244 12.5995 15.5789 12.754C15.7334 12.9085 15.821 13.1175 15.8229 13.336C15.8248 13.5545 15.7408 13.765 15.589 13.9222L10.589 18.9222C10.4327 19.0784 10.2208 19.1662 9.99985 19.1662C9.77888 19.1662 9.56696 19.0784 9.41069 18.9222L4.41068 13.9222Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDown);
export default __webpack_public_path__ + "static/media/icon-down.ac1c2d8b5df5a934b4e34b80d508b68d.svg";
export { ForwardRef as ReactComponent };